module.exports = __webpack_public_path__ + "static/dance-of-souls-b10c6250bed5a6f7c41dfbbd3523ff2a.jpg";